import { render, staticRenderFns } from "./TrophyIcon.vue?vue&type=template&id=79f7c198&scoped=true"
import script from "./TrophyIcon.vue?vue&type=script&lang=js"
export * from "./TrophyIcon.vue?vue&type=script&lang=js"
import style0 from "./TrophyIcon.vue?vue&type=style&index=0&id=79f7c198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7c198",
  null
  
)

export default component.exports